import type { FC } from 'react'
import type { EntryLinkBlock } from '@contentful/rich-text-types'
import type { Asset, Entry, EntrySkeletonType } from 'contentful'
import {
  TypeArticle,
  TypeBlogImage,
  TypeCallOut,
  TypeCopyableBox,
  TypeDescriptiveSlider,
  TypeDoDont,
  TypeExpertTip,
  TypeExpertTipV2,
  TypeHighlightedText,
  TypeInteractiveBanner,
  TypeResources,
  TypeSalaryByExperience,
  TypeSalaryByLocation,
  TypeSalaryRange,
  TypeStatisticalInsights,
  TypeTopSkills,
  TypeVideoUpload,
} from './contentful'

export enum ContentfulType {
  // Asset = 'Asset',
  InlineAsset = 'InlineAsset',
  ExpertTip = 'ExpertTip',
  ExpertTipV2 = 'ExpertTipV2',
  Article = 'Article',
  Video = 'Video',
  CopyableBox = 'CopyableBox',
  StatisticalInsight = 'StatisticalInsight',
  DoDont = 'DoDont',
  CallOut = 'callOut',
  Resources = 'resources',
  BlogImage = 'blogImage',
  InteractiveBanner = 'interactiveBanner',
  HighlightedText = 'highlightedText',
  DescriptiveSlider = 'descriptiveSlider',
  TopSkills = 'topSkills',
  SalaryRange = 'salaryRange',
  SalaryByLocation = 'salaryByLocation',
  SalaryByExperience = 'salaryByExperience',
}

export type CustomElementProps<T> = {
  node: EntryLinkBlock | Asset
  children: React.ReactNode
  reference: Entry<EntrySkeletonType, 'WITHOUT_UNRESOLVABLE_LINKS', string>
  type?: T // find a way to infer T on the reference.
}

export type CustomElementMap = {
  [K in ContentfulType]: FC<CustomElementProps<ReferenceTypeMap[K]>>
}

export type ReferenceTypeMap = {
  // [ContentfulType.Asset]: Asset
  [ContentfulType.ExpertTip]: TypeExpertTip<'WITHOUT_UNRESOLVABLE_LINKS', string>
  [ContentfulType.CopyableBox]: TypeCopyableBox<'WITHOUT_UNRESOLVABLE_LINKS', string>
  [ContentfulType.StatisticalInsight]: TypeStatisticalInsights<'WITHOUT_UNRESOLVABLE_LINKS', string>
  [ContentfulType.DoDont]: TypeDoDont<'WITHOUT_UNRESOLVABLE_LINKS', string>
  [ContentfulType.Article]: TypeArticle<'WITHOUT_UNRESOLVABLE_LINKS', string>
  [ContentfulType.Video]: TypeVideoUpload<'WITHOUT_UNRESOLVABLE_LINKS', string>
  [ContentfulType.CallOut]: TypeCallOut<'WITHOUT_UNRESOLVABLE_LINKS', string>
  [ContentfulType.Resources]: TypeResources<'WITHOUT_UNRESOLVABLE_LINKS', string>
  [ContentfulType.BlogImage]: TypeBlogImage<'WITHOUT_UNRESOLVABLE_LINKS', string>
  [ContentfulType.InlineAsset]: TypeArticle<'WITHOUT_UNRESOLVABLE_LINKS', string>
  [ContentfulType.InteractiveBanner]: TypeInteractiveBanner<'WITHOUT_UNRESOLVABLE_LINKS', string>
  [ContentfulType.HighlightedText]: TypeHighlightedText<'WITHOUT_UNRESOLVABLE_LINKS', string>
  [ContentfulType.ExpertTipV2]: TypeExpertTipV2<'WITHOUT_UNRESOLVABLE_LINKS', string>
  [ContentfulType.BlogImage]: TypeBlogImage<'WITHOUT_UNRESOLVABLE_LINKS', string>
  [ContentfulType.DescriptiveSlider]: TypeDescriptiveSlider<'WITHOUT_UNRESOLVABLE_LINKS', string>
  [ContentfulType.TopSkills]: TypeTopSkills<'WITHOUT_UNRESOLVABLE_LINKS', string>
  [ContentfulType.SalaryRange]: TypeSalaryRange<'WITHOUT_UNRESOLVABLE_LINKS', string>
  [ContentfulType.SalaryByLocation]: TypeSalaryByLocation<'WITHOUT_UNRESOLVABLE_LINKS', string>
  [ContentfulType.SalaryByExperience]: TypeSalaryByExperience<'WITHOUT_UNRESOLVABLE_LINKS', string>
}
